
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learner/[learnerUID]",
      function () {
        return require("private-next-pages/learner/[learnerUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learner/[learnerUID]"])
      });
    }
  